<!--家电共同被保险人-->
<template>
	<div>
		<el-card>
			<template slot="header">
				<div style="display: flex; justify-content: space-between; margin-right: 20px">
					<span style="font-size: 14px; line-height: 35px">共同被保险人</span>
					<el-tooltip effect="light" placement="top">
						<template #content>
							<div style="white-space: pre-line">
								同一人通过亲属实际控制多个网点、网点间 代结、上下级网点关系，如有上述共同被保 险企业应在投保时列明
							</div>
						</template>
						<el-button icon="el-icon-plus" type="primary" @click="onAddUnits">增加共同被保险人</el-button>
					</el-tooltip>
				</div>
			</template>

			<avue-crud
				ref="crud"
				:data="insuredData"
				:option="optionInsured"
				:table-loading="tableLoading"
				@row-del="onRowDel"
				@cell-mouse-leave="onCellMouseLeave"></avue-crud>

			<!--    <div style="display: flex;justify-content: center;margin-top: 20px">-->
			<!--      <el-button v-if="!isSubmitCar" icon="el-icon-check" type="primary" @click="onCarSubmit()">确认</el-button>-->
			<!--      <el-button v-else icon="el-icon-edit" type="default" @click="onCarEdit()">修改</el-button>-->
			<!--    </div>-->
		</el-card>

		<el-dialog :visible.sync="isShowAddDialog">
			<unit-common-form
				ref="unitForm"
				:productId="productId"
				unit-type="3"
				@onCheckSuccess="onCheckSuccess"></unit-common-form>
		</el-dialog>
	</div>
</template>

<script>
// 这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件等等）
// import { mapGetters } from 'vuex'

import {option_insured_form} from '@/const/crud/insurance/policy'
import {rule} from '@/util/validateRules'
import UnitCommonForm from '@/components/insurance/unitCommon'

export default {
	name: 'unitInsuredForm',
	mixins: [],
	components: {UnitCommonForm},
	props: {
		productId: {
			type: String | Number,
		},
		holderCode: String,
		formSubmit: Object,
		tableLoading: Boolean,
	},
	data() {
		return {
			optionInsured: this.deepClone(option_insured_form),
			insuredData: [],
			isSubmitCar: false,
			isShowAddDialog: false,
		}
	},
	computed: {
		// ...mapGetters(['userPermissions','buttonType'])
	},
	watch: {
		holderCode: {
			handler(newVal) {
				if (!this.validatenull(newVal)) {
					//判断是否有重复的
					this.onJudgeUnitSame(newVal)
				}
			},
			immediate: true,
		},
	},
	methods: {
		onAddUnits() {
			if (this.insuredData.length >= 3) {
				this.$alert('最多只能增加3个共同被保险人！', '提示').then(() => {})
				return
			}
			this.isShowAddDialog = true
		},
		onCheckSuccess(unitData) {
			if (!this.validatenull(this.holderCode) && unitData.unit_code === this.holderCode) {
				let {unit_name, unit_code} = unitData
				this.$alert(`企业信用代码：${unit_code}是投保企业，请修改共同被保险人`, '提示', {}).then(() => {})
				return
			}
			if (this.insuredData.length > 0) {
				let tempIndex = this.insuredData.findIndex(({unit_code = ''}) => {
					return unit_code === unitData.unit_code
				})
				if (tempIndex !== -1) {
					this.$message.error('该企业已存在！')
					return
				}
			}
			this.isShowAddDialog = false
			this.insuredData.push(unitData)
			//清空
			this.$refs.unitForm.onRecycleData()
		},
		onRowDel(row, index) {
			this.insuredData.splice(index, 1)
		},
		//判断共同保险人和投保企业
		onJudgeUnitSame(newVal) {
			let tempResult = false
			if (!this.validatenull(this.holderCode) && this.insuredData.length > 0) {
				let tempIndex = this.insuredData.findIndex(({unit_code = ''}) => {
					return unit_code === newVal
				})
				if (tempIndex !== -1) {
					this.insuredData.splice(tempIndex, 1)
				}
			}
			return tempResult
		},
		//获取数据
		onGetInsuredData() {
			if (this.insuredData.length === 0) {
				return []
			}
			let tempData = this.deepClone(this.insuredData)
			tempData.forEach((itemData) => {
				itemData.area_code = itemData.area_code[2]
			})
			return tempData
			// return this.insuredData || []
		},

		//设置数据
		onSetGongBaoData(tempData) {
			this.insuredData = tempData.map((itemData) => {
				let {unit_name, unit_code, legal_person, legal_person_mobile, unit_addr, area_code, bus_license} = itemData
				return {
					unit_name,
					unit_code,
					legal_person,
					legal_person_mobile,
					unit_addr,
					area_code: [`${area_code.substr(0, 2)}0000`, `${area_code.substr(0, 4)}00`, area_code],
					bus_license,
				}
			})
		},

		onCellMouseLeave() {},
		onCarSubmit() {
			let {
				isHolderSubmitted = false,
				isPlanSubmitted = false,
				isPeriodSubmitted = false,
				isInsuredSubmitted = false,
				sameUnit = false,
			} = this.formSubmit
			let tempMsg = ''
			if (!isHolderSubmitted) {
				tempMsg = '请确认投保企业!'
			} else if (!isInsuredSubmitted && !sameUnit) {
				tempMsg = '请确认被保企业!'
			} else if (!isPlanSubmitted) {
				tempMsg = '请确认投保方案'
			} else if (!isPeriodSubmitted) {
				tempMsg = '请确认生效时间'
			}
			if (!this.validatenull(tempMsg)) {
				this.$message.error(tempMsg)
				return
			}
			//确认
			let {licenseNo = '', vin = '', insureSeatNum = '', seatNum = '', engineNo = ''} = this.insuredData[0]
			if (!licenseNo || !vin || !insureSeatNum || !seatNum || !engineNo) {
				this.$message.error('请完善保障车辆信息!')
				return
			}
			if (!rule.validatorCarMethod(licenseNo)) {
				this.$message.error('车牌号输入有误!')
				return
			}
			if (vin.length !== 17) {
				this.$message.error('车架号输入有误!')
				return
			}
			let message = ''
			if (this.validatenull(parseInt(insureSeatNum)) || this.validatenull(parseInt(seatNum))) {
				message = '投保座位数和核定座位数只能为数字'
			} else {
				if (parseInt(insureSeatNum) > parseInt(seatNum) && parseInt(insureSeatNum) !== 3) {
					message = '投保座位数不能大于核定座位数'
				}
			}
			if (!this.validatenull(message)) {
				this.$alert(message, '提示')
				return
			}
			//确定啦
			this.isSubmitCar = true
			this.insuredData[0].$cellEdit = false
			//算钱
			this.$emit('onSubmitCarData', [
				{
					licenseNo,
					vin,
					insureSeatNum,
					seatNum,
					engineNo,
				},
			])
		},
		onCarEdit() {
			this.insuredData[0].$cellEdit = true
			this.isSubmitCar = false
			this.$emit('onSubmitCarData', null)
		},
		setPremiumData({priceId, premium}) {
			let tempData = this.deepClone(this.insuredData[0])
			tempData.premium = premium
			tempData.price = premium * 100
			tempData.priceId = priceId
			this.insuredData = [tempData]
		},
		getCheckInsureData() {
			return this.insuredData
		},
		setDataCarForm(listData) {
			this.insuredData = listData
			this.insuredData[0].$cellEdit = true
			let {price = 0} = this.insuredData[0]
			if (price > 0) {
				this.insuredData[0].premium = price / 100
			}
		},
	},
	created() {},
	mounted() {},
	activated() {},
	updated() {},
	beforeDestroy() {},
	destroyed() {},
	beforeRouteEnter(to, from, next) {
		next()
	},
	beforeRouteUpdate(to, from, next) {
		next()
	},
	beforeRouteLeave(to, from, next) {
		next()
	},
}
</script>

<style lang="scss" scoped>
::v-deep .el-card__header {
	padding: 10px 20px;
}

::v-deep .el-button--mini {
	padding: 0 5px;
}

::v-deep .el-button {
	height: 28px;
}
</style>
